// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// ✅ Your Firebase config (copied exactly from Firebase console)
const firebaseConfig = {
  apiKey: "AIzaSyAPn7ak5oblhba-IGr-ldamuqCNc2ZyP70",
  authDomain: "maritime-dashboard-ee6c8.firebaseapp.com",
  projectId: "maritime-dashboard-ee6c8",
  storageBucket: "maritime-dashboard-ee6c8.appspot.com",
  messagingSenderId: "117445952974",
  appId: "1:117445952974:web:60691b7d5f06c46436579f",
  measurementId: "G-F0MJ50Z04G"   // ✅ update to this
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app, "maritime-dashboard");
export const analytics = getAnalytics(app);

export default app;
